import React from 'react';
import { Card, Tag, Input, Button, Switch, Typography, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import type { CockpitChainInfo, CockpitTraceConfig } from '../../../../services/devApi';
import { chainStatusColorMap, evidenceColorMap, formatRefreshTime } from './helpers';

const { Text } = Typography;

interface Props {
  chain: CockpitChainInfo;
  traceConfig: CockpitTraceConfig;
  docNo: string;
  traceLoading: boolean;
  autoRefresh: boolean;
  lastRefreshedAt: Date | null;
  hasTraceResult: boolean;
  onDocNoChange: (v: string) => void;
  onTrace: () => void;
  onAutoRefreshChange: (v: boolean) => void;
}

/** 右欄頂部：chain 資訊 + 單號輸入 + 追蹤 / 自動刷新控制 */
const CockpitControlCard: React.FC<Props> = ({
  chain,
  traceConfig,
  docNo,
  traceLoading,
  autoRefresh,
  lastRefreshedAt,
  hasTraceResult,
  onDocNoChange,
  onTrace,
  onAutoRefreshChange,
}) => {
  return (
    <Card size="small">
      {/* chain 名稱 + 狀態 */}
      <div className="flex items-center gap-2 mb-3 flex-wrap">
        <span className="font-bold" style={{ fontSize: 16 }}>
          {chain.chainName}
        </span>
        <span className="font-mono text-gray-400" style={{ fontSize: 12 }}>
          {chain.chainId}
        </span>
        <Tag color={chainStatusColorMap[chain.currentStatus] || 'default'}>
          {chain.currentStatus.replace(/_/g, ' ')}
        </Tag>
        <Tag color={evidenceColorMap[chain.evidenceLevel] || 'default'}>
          {chain.evidenceLevel.replace(/_/g, ' ')}
        </Tag>
      </div>

      {/* 單號輸入 + 控制列 */}
      <div className="flex items-center gap-4 flex-wrap">
        <Space.Compact>
          <Input
            addonBefore={traceConfig.docInputLabel}
            placeholder="輸入測試單號，如 CH3L1A"
            maxLength={traceConfig.docMaxLen > 0 ? traceConfig.docMaxLen : undefined}
            value={docNo}
            onChange={(e) => onDocNoChange(e.target.value)}
            onPressEnter={onTrace}
            style={{ width: 320 }}
            className="font-mono"
            allowClear
          />
          <Button
            type="primary"
            icon={<SearchOutlined />}
            loading={traceLoading}
            onClick={onTrace}
          >
            追蹤
          </Button>
        </Space.Compact>

        <div className="flex items-center gap-2">
          <Switch
            size="small"
            checked={autoRefresh}
            disabled={!hasTraceResult}
            onChange={onAutoRefreshChange}
          />
          <Text type="secondary" style={{ fontSize: 12 }}>
            自動刷新（每 5 秒）
          </Text>
        </div>

        <Text type="secondary" style={{ fontSize: 12 }}>
          最後刷新：{formatRefreshTime(lastRefreshedAt)}
        </Text>
      </div>
    </Card>
  );
};

export default CockpitControlCard;
